import { BrandEntities } from './BrandEntities'
import { General } from './General'
import { Menu } from './Menu'
import { UpButton } from './UpButton'
import { LoadingWrapperApps } from './LoadingWrapperApps'

export const Component = { BrandEntities, General, Menu, UpButton,LoadingWrapperApps }
